/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

import { lazyLoad } from "../LazyLoad";
const DATA_PIC_ATTR = "data-cms-src";
const DATA_PIC_SRCSET = "data-cms-srcset";

/**
 * Represents an infinity scroll gallery.
 */

/**
 * @param {Element} el
 * @param {Object} settings
 * @constructor
 */
const InifinityScrollGallery = function (el, settings) {
  this.galleryEl = el;
  let allImages = this.galleryEl.querySelectorAll("[data-image-el]");
  for (var i = 0, len = allImages.length; i < len; i += 1) {
    let img = allImages[i];
    img.onload = function () {
      // https://jira.dev.fb/browse/CMSB-3273
      this.setAttribute("data-cms-image-lazy-loaded", "true");
    };
    lazyLoad(allImages[i], target => {
      if (target.parentElement.tagName === "PICTURE") {
        let parent = target.parentElement;
        let sourcetags = parent.querySelectorAll(`[${DATA_PIC_SRCSET}]`);
        for (let i = 0, len = sourcetags.length; i < len; i += 1) {
          let sourceTag = sourcetags[i];
          sourceTag.setAttribute("srcset", sourceTag.getAttribute(DATA_PIC_SRCSET));
        }
      }
      target.setAttribute("src", target.getAttribute(DATA_PIC_ATTR));
    });
  }
};
export default InifinityScrollGallery;